import "./Contact.module.css";
import Navigation from "@/reusable_sections/Header";
import Contact from "./sections/Contact";
import Location from "./sections/Location";
import Faq from "./sections/Faq";
import Footer from "@/reusable_sections/Footer";
export default function ContactPage() {
  return <div>
      <Navigation />
      <Contact />
      <Location />
      <Faq />
      <Footer />
    </div>;
}